import React, {useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

import {classNames} from 'primereact/utils';
import {Button} from 'primereact/button';
import {InputText} from 'primereact/inputtext';
import {SplitButton} from 'primereact/splitbutton';
import {MenuItem} from 'primereact/menuitem';

import {LayoutContext} from 'src/layout/context/layoutcontext';
import {Detail} from './Detail';

export const Sign = () => {

  const {search} = useLocation();

  const {layoutConfig} = useContext(LayoutContext);
  const [code, setCode] = useState('');
  const [refresh, setRefresh] = useState(null)
  const [signingSecretCode, setSigningSecretCode] = useState(null)
  const [displayDetail, setDisplayDetail] = useState(null)

  useEffect(() => {
    if (search) {
      const params = new URLSearchParams(search);
      if (params.get('code')) {
        setCode(encodeURIComponent(params.get('code')));
      }
      if (params.get('signingSecretCode')) {
        setSigningSecretCode(encodeURIComponent(params.get('signingSecretCode')));
      }
    }
  }, [search]);
  useEffect(() => {
    if (code) {
      setDisplayDetail(code);
    }
  }, [code, refresh]);

  const downloadSignTool = (arch: '64' | '32' = '64') => {
    const fileName = arch === '64' 
      ? 'IAMSigningToolSetup64bit.zip' 
      : 'IAMSigningToolSetup32bit.zip';
    window.open(`/iam/tool/${fileName}`);
  }

  const toolMenuItems: MenuItem[] = [
    {
      label: 'Tải tool ký 64-bit',
      icon: 'pi pi-download',
      command: () => downloadSignTool('64')
    },
    {
      label: 'Tải tool ký 32-bit',
      icon: 'pi pi-download',
      command: () => downloadSignTool('32')
    }
  ]
  const submit = () => {
    setDisplayDetail(code);

  }

  const containerClass = classNames("layout-wrapper layout-static layout-static-inactive", {
    "p-ripple-disabled": !layoutConfig.ripple
  });

  return (
    <div className={containerClass}>

      <div className="layout-topbar">
        <div className="layout-topbar-logo">
          <img src="/iam/iam-econtract.png" alt="IAM-TASK" style={{height: '3.5rem'}}/>
        </div>
      </div>

      <div className="layout-main-container">
        <div className="flex flex-column align-items-center justify-content-center">
          <h2 className="uppercase mt-0 mb-5">Tra cứu hợp đồng điện tử</h2>
          <div className="flex flex-column mt-2 gap-2 ">
            <label htmlFor="contactNumber"><b>Mã tra cứu</b></label>
            <InputText value={code} onChange={e => setCode(e.target.value)} required
                       placeholder="Nhập mã tra cứu" style={{width: '25rem'}} autoFocus/>
          </div>
          <div className="flex flex-column mt-2 gap-2 ">
            <label htmlFor="contactNumber"><b>Mã bí mật</b></label>
            <InputText value={signingSecretCode} onChange={e => setSigningSecretCode(e.target.value)} required
                       placeholder="Nhập mã bí mật" style={{width: '25rem'}}/>
          </div>
          <div className=" mt-2  flex align-items-center justify-content-between">
            <Button label="Tra cứu" className={'mr-3'} icon="pi pi-search" severity="success"
                    onClick={submit}/>
            <SplitButton 
              label="Tải tool ký" 
              icon="pi pi-download" 
              severity="info"
              className={'ml-3'}
              onClick={() => downloadSignTool('64')}
              model={toolMenuItems}
            />
          </div>
        </div>
        <Detail display={displayDetail} setDisplay={setDisplayDetail} signingSecretCode={signingSecretCode} setSigningSecretCode={setSigningSecretCode} setRefresh={setRefresh}/>
      </div>
    </div>
  );
}